var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17 12 C 13.691 12 11 14.691 11 18 L 11 46 C 11 49.309 13.691 52 17 52 L 47 52 C 50.309 52 53 49.309 53 46 L 53 26 C 53 22.691 50.309 20 47 20 L 27 20 L 17 20 C 15.897 20 15 19.103 15 18 C 15 16.897 15.897 16 17 16 L 46 16 C 47.104 16 48 15.104 48 14 C 48 12.896 47.104 12 46 12 L 17 12 z M 15 23.650391 C 15.62647 23.872739 16.298142 24 17 24 L 27 24 L 47 24 C 48.103 24 49 24.897 49 26 L 49 46 C 49 47.103 48.103 48 47 48 L 17 48 C 15.897 48 15 47.103 15 46 L 15 23.650391 z M 42 33 C 40.343 33 39 34.343 39 36 C 39 37.657 40.343 39 42 39 C 43.657 39 45 37.657 45 36 C 45 34.343 43.657 33 42 33 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnWallet);
export default __webpack_public_path__ + "static/media/icn-wallet.e5703e159dfbd19f318fe14e4ce2823f.svg";
export { ForwardRef as ReactComponent };